<div class="container">
  <div class="row mt-2" [ngClass]="eventsManager.legalLanguage.adminBy === 'wellfit' ? 'mb-2' : ''">
    <div class="col-12 legal-text">
      <p>THIS PLAN IS NOT INSURANCE and is not intended to replace health insurance.</p>
      <span class="legal-text-bold">
        <span *ngIf="eventsManager.legalLanguage.adminBy == 'wellfit'">{{ templateName }}</span>
        {{ eventsManager.legalLanguage.prefix }}
      </span>
      <span [innerHTML]="eventsManager.legalLanguage.text"> </span>
      <span *ngIf="eventsManager.legalLanguage.adminBy == 'wellfit'">&nbsp;{{ dataService.PhoneNumber }}</span>
      <p class="mt-2">Not valid in the state of VT.</p>
    </div>
  </div>

  <div class="row mt-5 mb-5" *ngIf="eventsManager.legalLanguage.adminBy === 'careington'"></div>
</div>
